export default {
  clientSettings: "System settings",
  logout: "Sign out",
  showHelp: "Show help"
}
